import React, { useEffect } from 'react'
import './Home.css'
import { useStateValue } from '../../StateProvider';
import {useTranslation} from "react-i18next";


function Home() {
    const {t, i18n} = useTranslation('common');
    const HomeContainer = React.createRef();
    const [state, dispatch] = useStateValue();
    useEffect(() => {
        dispatch({
            type : "ADD_REF",
            ref : HomeContainer.current.offsetTop
        })
    }, [])
    const handleHire = (e) =>{
        e.preventDefault()
        window.scrollTo({
          top: state.Ref[5],
          left: 0,
          behavior: "smooth"
        });
      };
    return (
        <div ref={HomeContainer} className="home">
            <div className="home__info">
                <p>{t('home.hi')}</p>
                <h1>Berarma Oussama</h1>
                <p>{t('home.spec')}</p>
                <button onClick={handleHire}>{t('home.button')}</button>
            </div>
        </div>
    )
}

export default Home
